module.exports = __webpack_public_path__ + "img/qr-wechat.4db82503.svg";